var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2143 6H4.78571C4.35112 6 4 6.34531 4 6.77273V22.2273C4 22.6547 4.35112 23 4.78571 23H25.2143C25.6489 23 26 22.6547 26 22.2273V6.77273C26 6.34531 25.6489 6 25.2143 6ZM23.2304 8.62969L15.4837 14.558C15.2922 14.7053 15.0246 14.7053 14.833 14.558L7.08393 8.62969C7.05472 8.60752 7.03329 8.57691 7.02266 8.54216C7.01202 8.50742 7.0127 8.47026 7.02462 8.43592C7.03653 8.40157 7.05907 8.37175 7.08908 8.35064C7.11909 8.32953 7.15507 8.31818 7.19196 8.31818H23.1223C23.1592 8.31818 23.1952 8.32953 23.2252 8.35064C23.2552 8.37175 23.2778 8.40157 23.2897 8.43592C23.3016 8.47026 23.3023 8.50742 23.2916 8.54216C23.281 8.57691 23.2596 8.60752 23.2304 8.62969Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b36c79c3.svg";
export { ForwardRef as ReactComponent };